import { femaleAvatarBlueprint } from './femaleAvatar'
import { maleAvatarBlueprint } from './maleAvatar'

export const allAvatarBlueprints = [femaleAvatarBlueprint, maleAvatarBlueprint]
